var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nodes.length > 0 && !_vm.nodes.length)?_c('div',{staticClass:"c-loading"},[_c('spinner'),_vm._t("default",[_vm._v("Loading component...")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }